<script>
    import ProfileService from '../services/api/ProfileService';

    export default {
        name: "ProfileUpdate",
        methods: {
            saveProfileData(profileData){
                return ProfileService.saveProfile(profileData)
            },
            updateStoreProfile(profile) {
                this.$store.commit('updateProfileData', profile);
            }
        }
    }
</script>

<style scoped>

</style>
